export default angular
  .module("ModifyLinkToScriptCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyLinkToScriptController", [
    "$scope",
    "messageItemId",
    "resourceId",
    "resourceKind",
    "currentLink",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "Aliases",
    function (
      $scope,
      messageItemId,
      resourceId,
      resourceKind,
      currentLink,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      Aliases,
    ) {
      const assigned = { ...currentLink };
      $scope.resourceId = resourceId;
      $scope.resourceKind = resourceKind;

      if ($scope.resourceKind === "script") {
        $scope.scripts = Scripts.getScripts;
        $scope.loading = Scripts.loading;
        Scripts.loadScripts("all");
      } else {
        $scope.aliases = Aliases.getAliases;
        $scope.loading = Aliases.loading;
        Aliases.loadAliases();
      }
      // default script list view settings
      $scope.scriptPageSize = 10;
      $scope.searchString = "";
      $scope.sortResources = [];
      $scope.sortResources.column = "ID";
      $scope.sortResources.direction = false; // descending direction

      $scope.assignedID = $scope.resourceId;
      $scope.setAssigned = function (scriptOrAlias) {
        assigned.ID = scriptOrAlias.ID ? scriptOrAlias.ID : scriptOrAlias.SYS_ID;
        assigned.TITLE = scriptOrAlias.TITLE ? scriptOrAlias.TITLE : scriptOrAlias.DEF;
      };
      $scope.assignedIDSET = $scope.assignedID;

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortResources.column === column) {
          $scope.sortResources.direction = !$scope.sortResources.direction;
        } else {
          $scope.sortResources.column = column;
          $scope.sortResources.direction = false;
        }
      };

      $scope.ok = () => $modalInstance.close({ action: "link", payload: { ...assigned } });
      $scope.remove = () => $modalInstance.close({ action: "unlink", payload: { ID: "", TITLE: "" } });
      $scope.cancel = () => $modalInstance.dismiss({ action: "cancel", payload: currentLink });
    },
  ]);
